// Build ID: 2026-06-24-18-00-REBUILD
console.log("App initialized with Build ID: 2026-06-24-18-00-REBUILD");
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Editor from "@/pages/Editor";
import Upgrade from "@/pages/Upgrade";
import Published from "@/pages/Published";
import "@/App.css";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="h-screen w-screen flex items-center justify-center bg-[#E5E7EB]">
        <div className="font-display text-xl text-gray-500">Loading CreativeHub…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/dashboard" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="bottom-right" richColors duration={2500} />
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
          <Route path="/register" element={<PublicOnly><Register /></PublicOnly>} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/editor/:projectId" element={<ProtectedRoute><Editor /></ProtectedRoute>} />
          <Route path="/upgrade" element={<ProtectedRoute><Upgrade /></ProtectedRoute>} />
          <Route path="/upgrade/success" element={<ProtectedRoute><Upgrade success /></ProtectedRoute>} />
          <Route path="/upgrade/cancel" element={<ProtectedRoute><Upgrade cancel /></ProtectedRoute>} />
          <Route path="/published/:slug" element={<Published />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
